export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6991.74bab626.jpg";